import { JQueryInput } from "./types";

(function (skyward, $)
{
    type PromiseResolution = (element: Element) => void;
    type UnloadHandler = { promise: Promise<Element>, resolve: PromiseResolution, reject: PromiseResolution; };

    const handlers: Map<Element, UnloadHandler> = new Map();
    const nodeRemovalObserver = new MutationObserver(mutationHandler);

    skyward.window.registerDOMUnloadCallback = registerDOMUnloadCallback;
    skyward.window.removeDOMUnloadCallback = removeDOMUnloadCallback;

    function registerDOMUnloadCallback(element: Element): Promise<Element>;
    function registerDOMUnloadCallback(element: JQueryInput): Promise<Element> | undefined;
    function registerDOMUnloadCallback(input: Element | JQueryInput): Promise<Element> | undefined
    {
        const element = $(input).get(0);
        if (!element)
        {
            return undefined;
        }
        element.classList.add("js-unload-action-applied");
        let resolve: PromiseResolution | undefined;
        let reject: PromiseResolution | undefined;
        const promise = new Promise<Element>((res, rej) =>
        {
            resolve = res;
            reject = rej;
        });
        handlers.set(element, { promise, resolve: resolve!, reject: reject! });

        if (handlers.size === 1)
        {
            nodeRemovalObserver.observe(document, { childList: true, subtree: true });
        }

        return promise;
    }

    function removeDOMUnloadCallback(input: JQueryInput)
    {
        const element = $(input).get(0);
        if (!element)
        {
            return undefined;
        }
        element.classList.remove("js-unload-action-applied");
        const handler = handlers.get(element);
        if (!handler)
        {
            return false;
        }
        handler.reject(element);

        handlers.delete(element);
        if (handlers.size === 0)
        {
            nodeRemovalObserver.disconnect();
        }
        return true;
    }

    function mutationHandler(mutations: MutationRecord[], observer: MutationObserver)
    {
        if (!mutations.some(mutation => hasAnyRemovals(mutation)))
        {
            return;
        }

        // Check if each observed element is detached and call its handler.
        // We can't search in the mutations' removed element lists for handled elements, because the removed elements
        // may have been modified after removal from the DOM but before the mutation observer was called.
        // For example, in detailspanel.ts, the details panel is .detach()ed and then emptied.
        handlers.forEach((handler, element) =>
        {
            if (!element.isConnected)
            {
                handlers.delete(element);
                handler.resolve(element);
            }
        });
        if (handlers.size === 0)
        {
            observer.disconnect();
        }
    }

    function hasAnyRemovals({ removedNodes }: MutationRecord)
    {
        for (let i = 0; i < removedNodes.length; i += 1)
        {
            const removedNode = removedNodes[i];
            if ((removedNode.nodeType === Node.ELEMENT_NODE ||
                removedNode.nodeType === Node.DOCUMENT_NODE ||
                removedNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) &&
                !removedNode.isConnected)
            {
                return true;
            }
        }
        return false;
    }

})(window.skyward, window.jQuery);
